export default {"src":"/_next/static/media/kleedkamers.0828f3d4.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};